import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../components/Footer';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft, FiShield } = FiIcons;

const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-[#004d44]">
      <nav className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur-md shadow-sm py-4">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
          <a href="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 rounded-lg bg-[#00a48c] text-white flex items-center justify-center font-black">S</div>
            <span className="text-xl font-black tracking-tight">Simulation Rendement PER</span>
          </a>
          <a href="/" className="flex items-center gap-2 text-sm font-bold text-[#00a48c] hover:underline">
            <SafeIcon icon={FiArrowLeft} /> Retour à l'accueil
          </a>
        </div>
      </nav>

      <main className="pt-32 pb-20 px-4">
        <div className="max-w-4xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 rounded-2xl bg-[#f0fcf9] text-[#00a48c] flex items-center justify-center text-2xl">
                <SafeIcon icon={FiShield} />
              </div>
              <h1 className="text-4xl font-black uppercase tracking-tight">Politique de Confidentialité</h1>
            </div>

            <div className="prose prose-slate max-w-none space-y-8 text-gray-600 font-medium leading-relaxed">
              <section className="bg-gray-50 p-8 rounded-[2rem] border border-gray-100">
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">1. Collecte des données</h2>
                <p>Dans le cadre de l'utilisation de notre simulateur, nous collectons les informations suivantes :</p>
                <ul className="list-disc pl-5 mt-4 space-y-2">
                  <li>Coordonnées (Nom, Prénom, Email, Téléphone)</li>
                  <li>Informations fiscales (Tranche Marginale d'Imposition)</li>
                  <li>Projets d'investissement</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">2. Finalités du traitement</h2>
                <p>Vos données sont traitées pour les finalités suivantes :</p>
                <ul className="list-disc pl-5 mt-4 space-y-2">
                  <li>Réalisation de la simulation personnalisée de rendement PER</li>
                  <li>Mise en relation avec un conseiller expert du Groupe Vaillance Conseil</li>
                  <li>Envoi d'informations relatives à votre projet de retraite</li>
                  <li>Mesurer l'attribution et l'efficacité de nos campagnes publicitaires (suivi des conversions). Les données personnelles telles que l'email et le numéro de téléphone sont hachées (anonymisées) avant d'être partagées avec nos partenaires publicitaires comme Google.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">3. Conservation des données</h2>
                <p>Les données sont conservées pendant la durée nécessaire à la réalisation des finalités précitées, dans la limite de 3 ans après le dernier contact, sauf obligation légale contraire.</p>
              </section>

              <section>
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">4. Vos droits (RGPD)</h2>
                <p>Conformément au Règlement Général sur la Protection des Données, vous disposez d'un droit d'accès, de rectification, d'effacement et de portabilité de vos données. Vous pouvez exercer ces droits en contactant notre DPO à l'adresse : <strong>m.saad@groupevaillance.fr</strong>.</p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PolitiqueConfidentialite;